import React from 'react';
import { ClientPortalLayout } from './ClientPortalLayout';
export function DiagnosticIntakePage() {
  return <ClientPortalLayout data-id="element-378">
      <div className="p-6 lg:p-8 max-w-4xl mx-auto space-y-6" data-id="element-379">
        {/* Executive Sponsor Intake */}
        <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden shadow-sm" data-id="element-380">
          <div className="p-8 border-b border-slate-100 flex justify-between items-start" data-id="element-381">
            <div data-id="element-382">
              <h1 className="font-serif-display text-2xl text-slate-900 mb-1" data-id="element-383">
                Executive Sponsor Intake
              </h1>
              <p className="text-sm text-slate-500" data-id="element-384">
                To be completed by the primary stakeholder
              </p>
            </div>
            <span className="px-3 py-1 bg-amber-100 text-amber-700 text-xs font-bold rounded-full" data-id="element-385">
              In Progress
            </span>
          </div>

          <div className="p-8 space-y-10" data-id="element-386">
            {/* Section 1 */}
            <section data-id="element-387">
              <h2 className="text-sm font-bold text-slate-900 uppercase tracking-wider mb-6 font-serif-display" data-id="element-388">
                1. Leadership Priorities
              </h2>
              <div className="space-y-6" data-id="element-389">
                <div data-id="element-390">
                  <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-391">
                    What is the single most important outcome for this retreat?
                  </label>
                  <textarea className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl text-sm text-slate-700 focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 outline-none resize-none" rows={3} defaultValue="We need to align the leadership team on how to balance R&D investment in our legacy pipeline versus our new gene therapy initiatives over the next 24 months." data-id="element-392" />
                </div>
                <div data-id="element-393">
                  <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-394">
                    What are the primary business objectives?
                  </label>
                  <textarea className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl text-sm text-slate-700 focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 outline-none resize-none" rows={2} defaultValue="Accelerate clinical trial timelines, establish a unified commercial strategy, improve cross-team collaboration." data-id="element-395" />
                </div>
              </div>
            </section>

            {/* Section 2 */}
            <section data-id="element-396">
              <h2 className="text-sm font-bold text-slate-900 uppercase tracking-wider mb-6 font-serif-display" data-id="element-397">
                2. Team Dynamics
              </h2>
              <div className="space-y-6" data-id="element-398">
                <div data-id="element-399">
                  <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-400">
                    Are there any known alignment issues or tensions?
                  </label>
                  <textarea className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl text-sm text-slate-700 focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 outline-none resize-none" rows={3} defaultValue="The commercial team feels R&D is moving too slowly on regulatory submissions, while R&D feels commercial is over-promising timelines to stakeholders." data-id="element-401" />
                </div>
              </div>
            </section>

            {/* Section 3 */}
            <section data-id="element-402">
              <h2 className="text-sm font-bold text-slate-900 uppercase tracking-wider mb-6 font-serif-display" data-id="element-403">
                3. Success Metrics
              </h2>
              <div className="space-y-6" data-id="element-404">
                <div data-id="element-405">
                  <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-406">
                    How will we measure the success of this offsite 30 days
                    post-event?
                  </label>
                  <textarea className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl text-sm text-slate-700 focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 outline-none resize-none" rows={2} defaultValue="Clear ownership map for the top 3 strategic initiatives, and a measurable increase in cross-functional trust scores." data-id="element-407" />
                </div>
              </div>
            </section>
          </div>
        </div>

        {/* Pulse Survey Card */}
        <div className="bg-white rounded-2xl border border-slate-200 p-8 shadow-sm" data-id="element-408">
          <div className="flex justify-between items-start mb-6" data-id="element-409">
            <div data-id="element-410">
              <h2 className="font-serif-display text-2xl text-slate-900 mb-1" data-id="element-411">
                Participant Pulse Survey
              </h2>
              <p className="text-sm text-slate-500" data-id="element-412">
                Pre-event diagnostic sent to all 32 attendees
              </p>
            </div>
            <div className="text-right" data-id="element-413">
              <div className="text-2xl font-serif-display text-slate-900" data-id="element-414">
                78%
              </div>
              <div className="text-xs text-slate-500" data-id="element-415">25 of 32 responses</div>
            </div>
          </div>

          <div className="h-2 bg-slate-100 rounded-full overflow-hidden mb-8" data-id="element-416">
            <div className="h-full bg-emerald-500 rounded-full" style={{
            width: '78%'
          }} data-id="element-417" />
          </div>

          <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-4" data-id="element-418">
            Anonymized Highlights
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-419">
            <div className="p-4 bg-slate-50 rounded-xl border border-slate-100" data-id="element-420">
              <p className="text-sm text-slate-600 italic" data-id="element-421">
                "We need more clarity on how the new regulatory guidelines will
                impact our Q3 launch."
              </p>
            </div>
            <div className="p-4 bg-slate-50 rounded-xl border border-slate-100" data-id="element-422">
              <p className="text-sm text-slate-600 italic" data-id="element-423">
                "Looking forward to finally getting R&D and Commercial in the
                same room to hash out timelines."
              </p>
            </div>
          </div>
        </div>
      </div>
    </ClientPortalLayout>;
}